const MOBILE_WIDTH = 768;
export const isMobileView = () => window.innerWidth < MOBILE_WIDTH;
